"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[6155],{

/***/ 14423:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76653);
/* harmony import */ var elephant_web_client_clinician_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65460);
/* harmony import */ var elephant_web_client_routes_history_LocationHistoryProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58264);
/* harmony import */ var elephant_web_client_patient_search_links__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87268);





const ClinicianDashboardPage = () => {
  const { locationHistory } = (0,elephant_web_client_routes_history_LocationHistoryProvider__WEBPACK_IMPORTED_MODULE_2__/* .useLocationHistoryContext */ .JZ)();
  const locations = locationHistory.slice(0, locationHistory.length - 1);
  const recentClinicianPageIndex = (0,elephant_web_client_clinician_links__WEBPACK_IMPORTED_MODULE_1__/* .mostRecentClinicianActionLocationIndex */ .xG)(locations);
  const lastLocation = locations[recentClinicianPageIndex];
  if (lastLocation && lastLocation.pathname !== (0,elephant_web_client_clinician_links__WEBPACK_IMPORTED_MODULE_1__/* .linkToClinicianDashboard */ .fV)()) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Navigate */ .Fg, {
      to: {
        pathname: lastLocation.pathname,
        search: lastLocation.search
      },
      state: lastLocation.state,
      replace: true
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Navigate */ .Fg, {
    to: {
      pathname: (0,elephant_web_client_patient_search_links__WEBPACK_IMPORTED_MODULE_4__/* .linkToPatientSearch */ .O)()
    },
    replace: true
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ClinicianDashboardPage);


/***/ })

}]);